/**
 * Matches "dev.myptv.com", "staging.myptv.com" or "myptv.com".
 * */
const deploymentHostPattern = /(dev\.|staging\.|prod\.)?myptv\.com/g;

/**
 * This function returns the deployment host URL depending on the base of the page.
 * E.g., depending on the deployment, this function returns:
 *     dev.myptv.com
 *     staging.myptv.com
 *     myptv.com
 * */
export const getDeploymentHost =() => {
    const absoluteUrl = window.location.href;
    const hostMatches = absoluteUrl.match(deploymentHostPattern);
    if (hostMatches) {
      return hostMatches[0];
    } else {
      // for local usage. Deployments should always have a myptv domain
      return "localhost"
    }
}

/**
 * This function adds the prefix and appends the specified path to the deployment host URL.
 * E.g., depending on the deployment, this function returns:
 *     https://[prefix].dev.myptv.com/[path]
 *     https://[prefix].staging.myptv.com/[path]
 *     https://[prefix].myptv.com/[path]
 * */
export const addDeploymentHost = (prefix, path) => {
  if (getDeploymentHost() !== "localhost") {
    return "https://" + prefix + "." + getDeploymentHost() + "/" + path.replace(/^\//, "");
  } else {
    // for local usage. Deployments should always have a myptv domain
    return "https://" + prefix + ".dev.myptv.com/" + path.replace(/^\//, "");
  }
}

export const addDeploymentHostApiProxy = (path) => {
  if (getDeploymentHost() !== "localhost") {
    return "https://developer-applications."+ getDeploymentHost() +"/apiproxy/" +
      path.replace(/^\//, "");
  } else {
    // for local usage. Deployments should always have a myptv domain
    if (path.includes("?")) {
      return "https://api.dev.myptv.com/" +
        path.replace(/^\//, "") + "&apiKey=" + apiKey;
    } else {
      return "https://api.dev.myptv.com/" +
        path.replace(/^\//, "") + "?apiKey=" + apiKey;
    }
  }
}

export const apiKey = "YOUR_API_KEY";
